import { SelectedProductUUID } from './selectedProductsTypes';

export class SelectedProductCache {
  static selectedProductInCreateMessageForm() {
    return 'selected-product-in-create-message-form';
  }

  static selectedCompanyProductInCreateMessageForm() {
    return 'selected-company-product-in-create-message-form';
  }

  static downloadUrls(uuid: SelectedProductUUID) {
    return `selected-product-${uuid}-download-urls`;
  }
}
